//If adding here, also update DomainStore.fetchDomainStatus and in Result.vue.currentTld

const TLD = {
  COM: "COM",
  NET: "NET",
  IO: "IO",
};

export default Object.freeze(TLD);